import React from 'react';
import './ApplicationIdWithStatusDot.scss';

const ApplicationIdWithStatusDot = ({
  applicationId,
  needsAction = false,
  noTruncate = false,
}) => (
    <div className={`application-id-cell${noTruncate ? ' application-id-cell--full' : ''}`}>
        {needsAction ? (
            <div className="blinking-circle">
                <span className="hover-text">Needs Action</span>
            </div>
        ) : (
            <div className="empty-circle" aria-hidden="true" />
        )}
        <span className="application-id-cell__id" title={applicationId}>
            {applicationId}
        </span>
    </div>
);

export default ApplicationIdWithStatusDot;
